export enum AppRouteParts {
  Main = 'ti',
}

export class AppRoutes {
  static Main = `/${AppRouteParts.Main}`;
}
